import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./api/apiSlice";

import categoriesSlice from "./categories/categoriesSlice";
import productsSlice from './products/productsSlice'
import userSlice from "./user/userSlice";
import usersSlice from "./users/usersSlice";
import adminSlice from "./admin/adminSlice";
import ordersSlice from "./orders/ordersSlice";
import homePageSlice from "./homePage/homePageSlice";
import postersSlice from "./posters/postersSlice";
import favoritesSlice from "./favorites/favoritesSlice";
import reviewsSlice from "./reviews/reviewsSlice";
import contactsSlice from "./contacts/contactsSlice";
import breadcrumbSlice from "./breadcrumb/breadcrumbSlice";

const store = configureStore({
  reducer: {
    categories: categoriesSlice,
    products: productsSlice,
    user: userSlice,
    users: usersSlice,
    admin: adminSlice,
    orders: ordersSlice,
    homePage: homePageSlice,
    posters: postersSlice,
    favorites: favoritesSlice,
    reviews: reviewsSlice,
    contacts: contactsSlice,
    breadcrumb: breadcrumbSlice,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getMiddleware) => getMiddleware().concat(apiSlice.middleware),
  devTools: true,
})

export default store;